module.exports = __webpack_public_path__ + "img/plyr-pause.9c227f21.svg";